/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bleeding.reducer';

export const BleedingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bleedingEntity = useAppSelector(state => state.bleeding.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bleedingDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bleeding.detail.title">Bleeding</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bleeding.id">Id</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.id}</dd>
          <dt>
            <span id="level">
              <Translate contentKey="tinyMedicRestApp.bleeding.level">Level</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.level}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="tinyMedicRestApp.bleeding.color">Color</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.color}</dd>
          <dt>
            <span id="clots">
              <Translate contentKey="tinyMedicRestApp.bleeding.clots">Clots</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.clots}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.bleeding.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bleeding.active">Active</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.bleeding.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bleeding.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bleeding.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bleeding.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bleeding.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.timestampEntry}</dd>
          <dt>
            <span id="cntPadsChanged">
              <Translate contentKey="tinyMedicRestApp.bleeding.cntPadsChanged">Cnt Pads Changed</Translate>
            </span>
          </dt>
          <dd>{bleedingEntity.cntPadsChanged}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bleeding.cycleDay">Cycle Day</Translate>
          </dt>
          <dd>{bleedingEntity.cycleDay ? bleedingEntity.cycleDay.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/bleeding" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bleeding/${bleedingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BleedingDetail;
